import React from 'react';
import PropTypes from 'prop-types';

import BetCard from '~shared/components/react/BetCard';
import EventDescription from '~shared/components/react/EventDescription/EventDescription';

import {
    sortSelections,
    addMissingSelections,
    isSelectionsBetable,
} from '~shared/utils/widgets';

/**
 * alternative to createBetCard() & createThreeMarketBetCard() functions from Widget.js,
 * createBetCard & createThreeMarketBetCard function converted to a component
 * @returns {JSX} list of betcards from the events passed in the props
 */
const BetCardsList = ({ events, gtmAttribute }) => {
    return (
        events.map(event => {
            const {
                id,
                inplay,
                markets,
                is_inplay,
                isUsFormat,
                usesThreeMarketView,
                grouped_market_ids: marketOrder,
                betable: isBetableEvent,
            } = event;

            // for single market view
            const [firstMarketId] = Object.keys(markets);
            const firstMarket = markets[firstMarketId];
            const { selection_schema, selections, betable: isBetableMarket } = firstMarket;

            // Check for any missing selections / sort
            const betCardSelections = usesThreeMarketView
                ? []
                : sortSelections(addMissingSelections(selections, selection_schema), isUsFormat);

            const betable = usesThreeMarketView
                ? isBetableEvent && isSelectionsBetable(markets)
                : isBetableEvent && isBetableMarket;

            const betCardProps = {
                betable,
                isLive: Boolean(inplay || is_inplay),
                selections: betCardSelections,
                markets,
                description: <EventDescription event={event} isDateHidden />,
                gtmAttribute,
            };

            const threeMarketViewProps = usesThreeMarketView
                ?
                    {
                        marketOrder,
                        usesThreeMarketView,
                        isUsFormat,
                    }
                :
                    {};

            return <BetCard key={id} { ...betCardProps } { ...threeMarketViewProps } />;
        })
    );
};

BetCardsList.propTypes = {
    events: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        betable: PropTypes.bool,
        markets: PropTypes.shape({
            betable: PropTypes.bool,
            selections: PropTypes.object,
        }),
        inplay: PropTypes.bool,
        is_inplay: PropTypes.bool,
        isUsFormat: PropTypes.bool,
        usesThreeMarketView: PropTypes.bool,
        grouped_market_ids: PropTypes.arrayOf(PropTypes.number),
    })).isRequired,
    gtmAttribute: PropTypes.string,
};

export default BetCardsList;
